const STATUS_LABELS = {
  draft: 'Черновик',
  pending: 'На проверке',
  approved: 'Подтверждён',
  rejected: 'Отклонён',
  blocked: 'Заблокирован',
  available: 'Доступна',
  in_use: 'В поездке',
  maintenance: 'ТО',
  repair: 'Ремонт',
  inspection_required: 'Нужен осмотр',
  active: 'Активна',
  finished_by_user: 'Завершена',
  confirmed_by_admin: 'Подтверждена',
  // Статусы задач. Их здесь не было вовсе: список задач показывал
  // сырое английское «open» с классом badge--open, которого нет
  // в стилях, — то есть подпись без оформления.
  open: 'Открыта',
  in_progress: 'В работе',
  on_review: 'На проверке',
  completed: 'Завершена',
  cancelled: 'Отменена',
}

export function StatusBadge({ status }) {
  // replace('_','-') заменял только первое подчёркивание:
  // finished_by_user превращался в finished-by_user и не находил класс.
  const cls = status?.replaceAll('_', '-') || 'draft'
  return (
    <span className={`badge badge--${cls}`}>
      {STATUS_LABELS[status] || status}
    </span>
  )
}
